import { validationClass } from './validationClass';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export const matchCentreEditFixture = {
    data() {
        return {
            showFixtureModal: false,
            selectedFixture: {},
            venueToggle : 0,
            page: null,
        }
    },
    created() {
        this.initialState();
    },
    components: {
        'date-picker': datePicker,
    },
    mixins: [validationClass],

    methods : {
        initialState() {
            this.selectedFixture = {
                live_score_type: null,
                live_score_id: null,
                live_stream_url : null,
                result: null,
                report_card_url: null,
                home_team_score: null,
                away_team_score: null,
                no_result: null,
                status_message: null,
                is_off: null,
                to_be_refixed: null,
                refixed: null,
                is_tie : null,
                is_draw: null,
                team_win: null,
                venue_id: null,
                venue_name: null,
                start_date: null,
                start_hour: null,
                start_minute: null,
            };
            this.errors.clear();

        },
        openFixtureModal(fixture, page) {
            this.selectedFixture = fixture;
            this.page = page;
            this.showFixtureModal = true;

            this.venueToggle = this.selectedFixture.venue_name ? 1 : 0;

            this.$nextTick(() => {
                $('.selectpicker').selectpicker('refresh');
            });
            
        },
        closeFixtureModal() {
            this.resetSelectedFixture();
            this.showFixtureModal = false;
            
        },
        resetSelectedFixture() {
            this.initialState();
        },
        updateFixture() {
            this.disableOnSubmit = true;
            let self = this;
            this.errors.clear();

            this.$validator.validateAll().then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    axios
                        .put(self.selectedFixture.update_fixture_url, self.selectedFixture)
                        .then(response => {
                            self.closeFixtureModal();
                            self.disableOnSubmit = false;
                            self.message = 'Fixture has been updated';

                            if (self.page == 'index') {
                                setTimeout(function(){
                                    self.getFixtures();
                                }, 1000);
                            } else {
                                location.reload();
                            }
                        })
                        .catch(error => {
                            if (error.response.status == 422) {
                                for (const [key, value] of Object.entries(error.response.data.errors)) {
                                    self.errors.add({
                                        field: key,
                                        msg: value[0]
                                    });
                                }
                            };  
                            self.disableOnSubmit = false;
                        });
                }

                if (!result) {
                    self.disableOnSubmit = false;
                    console.log('here');
                }
            });
        },
        toggleVenue() {
            if(this.venueToggle == 1) {
                this.selectedFixture.venue_id = null;
            } else if(this.venueToggle == 0) {
                this.selectedFixture.venue_name = null;
            }
            $('.selectpicker').selectpicker('refresh');
        },
    }
}
